import AddThemeScriptPng from "./AddThemeScript.png";

export const AddThemeScript = () => {
  return (
    <img
      id="add-theme-script"
      src={AddThemeScriptPng}
      alt="Add Theme Script"
      draggable="false"
      style={{ height: "100%", width: "auto", objectFit: "contain" }}
    />
  );
};
